import React, { useState } from "react";
import { Button } from 'react-bootstrap';
import BackButton from '../assets/images/arrow-left.svg';
import FavoriteButton from '../assets/images/heart.svg';
import SaveButton from '../assets/images/save.svg';
import ShareButton from '../assets/images/share.svg';
import { Row, Col } from "react-bootstrap";
import Photo from '../assets/images/photo.svg';
import AllPhotoModal from "./AllPhotoModal";
import { formatUploadedTag } from "../utils/date";
import useFavorites from "../hooks/useFavorites";
import ShareModal from "./ShareModal";
import DView from '../assets/images/3d-tour.svg';
import StreetView from '../assets/images/street-view.svg';
import SavePropertyButton from "./SavePropertyButton";


function ProductRentView({ property }) {
  const { isFavorite, toggleFavorite } = useFavorites(property.id);


  const [isHide, setIsHide] = useState(false);

  const handleHideClick = () => {
    setIsHide(!isHide);
  };

    const [isShare, setIsShare] = useState(false);
  
  const [showAllPhotoModal, setShowAllPhotoModal] = useState(false);
  const handleShowAllPhotoModal = () => setShowAllPhotoModal(true);
  const handleCloseAllPhotoModal = () => setShowAllPhotoModal(false);
  return (
    <>
      <div className="product-details-wrap-header">
        <Button  onClick={() => window.history.back()}  className='custom-bttn feed-button'><img src={BackButton} alt="" /> Feed</Button>
        <ul>
          <li><a className='active' href='#Overview' title='Overview'>Overview</a></li>
          <li><a href='#FloorPlan' title='Floor Plan'>Floor Plan</a></li>
          <li><a href='#Fees' title='Fees'>Fees</a></li>
          <li><a href='#Amenities' title='Amenities'>Amenities</a></li>
          <li><a href='#Schools' title='Schools'>Schools</a></li>
        </ul>
        <div className='button-group'>
          <Button
            className={`custom-bttn fhs-button ${isFavorite ? "active" : ""}`}
            onClick={toggleFavorite}
          >
            <img src={FavoriteButton} alt="" /> Favorite
          </Button>
          <SavePropertyButton
            property={property}
          />
         <Button
            className={`custom-bttn fhs-button ${isShare ? "active" : ""}`}
            onClick={() => setIsShare(true)}
          >
            <img src={ShareButton} alt="" /> Share
          </Button>
        </div>
      </div>
      <div className="product-details-wrap" id="Overview">

        <div className="product-details-wrap-box">
          <Row>
            {/* MAIN IMAGE */}
            <Col md={6} lg={5} className="main-img">
              <div className="img-view">
                {property.main_image && (
                  <img src={property.main_image} alt="Main property" />
                )}
              </div>
            </Col>

            {/* OTHER IMAGES */}
            <Col md={6} lg={7}>
              <Row className="h-100 row-group">
                {property.images.slice(0, 6).map((img, index) => (
                  <Col md={6} lg={4} key={index}>
                    <div className="img-view">
                      <img src={img} alt={`Property ${index + 1}`} />
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
          <span className="tag">{formatUploadedTag(property.primaryImageUploadedAt)}</span>
           <div className="button-group">
            <div className='tfs-group'>
              <a href={property.video_3D} target="_blank"
                className={`custom-bttn tfs-button`}
              >
                <img src={DView} alt="" /> 3D Video
              </a>
             
              <Button onClick={handleShowAllPhotoModal}
                className={`custom-bttn tfs-button`}
              >
                <img src={StreetView} alt="" /> Street View
              </Button>
            </div>
            <Button className={`custom-bttn tfs-button`}  onClick={handleShowAllPhotoModal}>
              <img src={Photo} alt="" /> {property.all_images.length} Photos
            </Button>
          </div>

        </div>
      </div>
      <AllPhotoModal show={showAllPhotoModal} property={property}  images={property.all_images} lat={property.latitude} long={property.longitude} handleClose={handleCloseAllPhotoModal} />
      <ShareModal
        title="Share Property"
        shareTitle={property.title}
        shareText={`Check out this ${property.property_type} in ${property.location}`}
        show={isShare}
         onClose={() => setIsShare(false)}
      />
    </>
  )
}
export default ProductRentView